<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><em>For Lorna, David, Hannah and Paul</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4b80ba4c